import filters from '..';
import config from '../config';

export default function resetAll() {
	filters.update((store) => {
		const newState = {
			...store,
			...config.initialValue
		};

		return newState;
	});
}
